'use strict';

require('./performance-review-questionnaire.scss');

module.exports = {
  template: require('./performance-review-questionnaire.html'),
  controller: require('./performance-review-questionnaire.controller'),
  controllerAs: 'vm',

  bindings: {
    token: '<',
    step: '<',
    data: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-questionnaire/index.js
 ** module id = 269
 ** module chunks = 0
 **/